import { useEffect } from "react";
import { useUser } from "../components/menu/auth/is_loggedin";
import { useAppDispatch } from "../redux/store";
import { setTheme } from "../redux/slices/uiPreferences";

export const useThemeEnforcement = () => {
  const user = useUser();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const savedTheme = localStorage.getItem("playerTheme");
    let theme = 0; // Default theme

    const parsedTheme = savedTheme ? parseInt(savedTheme) : 0;

    // If user has a premium theme selected but is not premium, reset to default
    if (parsedTheme > 1 && !user?.premium) {
      theme = 0;
      dispatch(setTheme(theme)); // setTheme handles both Redux and localStorage
    } else {
      theme = parsedTheme;
      dispatch(setTheme(theme));
    }
  }, [user?.premium, dispatch]);
};
